// import * as React from 'react';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import { Box, Typography } from '@mui/material';
import Footer from 'ui-component/foot';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTranslation } from 'react-i18next';
import { SET_CASE } from 'store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import zIndex from '@mui/material/styles/zIndex';

export default function TitlebarImageList() {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const goods = useSelector((state) => state.goods);
    const handleClick = (currentCase) => {
        dispatch({ type: SET_CASE, currentCase });
    };
    return (
        <Box className="caseList">
            <ImageListItem
                key="Subheader"
                cols={3}
                sx={{
                    width: '100%'
                }}
                id="back-to-top-anchor"
            >
                <ListSubheader
                    component="div"
                    sx={{
                        backgroundColor: '#F6F6F6',
                        color: '#333333',
                        fontSize: '28px',
                        fontWeight: 500,
                        height: 74,
                        p: { sm: 0.5, xs: 2 },
                        pl: { sm: 10 }
                    }}
                >
                    {t('nav-3')}
                </ListSubheader>
            </ImageListItem>
            <ImageList sx={{ width: '100%', height: '100%', m: 0 }} cols={isMobile ? 1 : 2} gap={0}>
                {goods.caseList.map((item, i) => (
                    <ImageListItem
                        key={i}
                        sx={{
                            overflow: 'hidden',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gridColumnEnd: !isMobile && (i < 1 || i === 3) ? 'span 2 !important' : ''
                        }}
                        col={!isMobile && (i < 1 || i === 3 ? 2 : 1)}
                        component={Link}
                        onClick={() => handleClick(item)}
                        to={`/goods?id=${item.id}`}
                        className="clickImg"
                    >
                        <img
                            src={`${item.img}?w=248&fit=crop&auto=format`}
                            srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                            alt={item.title}
                            loading="lazy"
                            className={isMobile ? 'scale2 autoH' : 'scale2'}
                        />
                        <ImageListItemBar
                            title={t(item.title)}
                            subtitle={t(item.address)}
                            sx={{
                                textShadow: '0px 0px 2px #000000',
                                fontWeight: 500,
                                background: 'none',
                                bottom: 'auto',
                                left: 'auto',
                                right: 'auto',
                                fontSize: '2.25rem',
                                textAlign: 'center',
                                zIndex: 3
                            }}
                        />
                    </ImageListItem>
                ))}
            </ImageList>
            <Footer />
        </Box>
    );
}
